module.exports = __webpack_public_path__ + "static/three-34f7592cdd22830e1d8e95b872e33043.svg";